'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ConnectionId$package$ConnectionId$() {
  this.alE = null;
  this.alF = false;
  $n_Lmealorama_ConnectionId$package$ConnectionId$ = this;
  $m_Lmealorama_ConnectionId$package$ConnectionId$();
}
export { $c_Lmealorama_ConnectionId$package$ConnectionId$ as $c_Lmealorama_ConnectionId$package$ConnectionId$ };
$p = $c_Lmealorama_ConnectionId$package$ConnectionId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ConnectionId$package$ConnectionId$;
/** @constructor */
function $h_Lmealorama_ConnectionId$package$ConnectionId$() {
}
export { $h_Lmealorama_ConnectionId$package$ConnectionId$ as $h_Lmealorama_ConnectionId$package$ConnectionId$ };
$h_Lmealorama_ConnectionId$package$ConnectionId$.prototype = $p;
$p.a2N = (function() {
  if ((!this.alF)) {
    this.alE = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lzio_json_JsonEncoder$().bg;
    this.alF = true;
  }
  return this.alE;
});
$p.aZb = (function() {
  $m_Lmealorama_ConnectionId$package$ConnectionId$();
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_ju_UUID$().aZd().m();
});
var $d_Lmealorama_ConnectionId$package$ConnectionId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ConnectionId$package$ConnectionId$, "mealorama.ConnectionId$package$ConnectionId$", ({
  FF: 1
}));
export { $d_Lmealorama_ConnectionId$package$ConnectionId$ as $d_Lmealorama_ConnectionId$package$ConnectionId$ };
var $n_Lmealorama_ConnectionId$package$ConnectionId$;
function $m_Lmealorama_ConnectionId$package$ConnectionId$() {
  if ((!$n_Lmealorama_ConnectionId$package$ConnectionId$)) {
    $n_Lmealorama_ConnectionId$package$ConnectionId$ = new $c_Lmealorama_ConnectionId$package$ConnectionId$();
  }
  return $n_Lmealorama_ConnectionId$package$ConnectionId$;
}
export { $m_Lmealorama_ConnectionId$package$ConnectionId$ as $m_Lmealorama_ConnectionId$package$ConnectionId$ };
//# sourceMappingURL=mealorama.-Connection-Id$package$-Connection-Id$.js.map
